module.exports = __webpack_public_path__ + "static/metaimg-7a3b90c46d02ce19afe481d0cefcac2d.png";